export default __webpack_public_path__ + "static/media/SingleDegreeDampingImg.6fa0c483.jpg";